import React from 'react';
import styles from './RichTextDescription.module.scss';
import TruncatedHtmlContent from '../TruncatedHtmlContent/TruncatedHtmlContent';

interface RichTextDescriptionProps {
  content: string;
  maxLength?: number;
}

const RichTextDescription: React.FC<RichTextDescriptionProps> = ({ content, maxLength = 700 }) => {
  if (!content) return null;

  return (
    <div className={styles['description-container']}>
      <TruncatedHtmlContent htmlContent={content} maxLength={maxLength} />
    </div>
  );
};

export default RichTextDescription;
